import styled from 'styled-components'

export const Container = styled.div`
  width: 60px;
  display: flex;
  justify-content: flex-end;

  > button {
    text-transform: none;
    font-size: 14px;
    background-color: #ED0772 !important;
    border-radius: 50px;
    color: rgb(255, 255, 255) !important;
    font-weight: 700;
    font-family: "Open Sans", sans-serif;
    text-decoration: none;
    height: 40px;
    width: 40px;
    min-width: 40px;
    line-height: normal;
    border: 2px solid #20597C;
  }

  .user-menu-drop{
    position: absolute;
    background: var(--white);
    width: 323px;
    right: 0;
    top: 96px;
    border-radius: 0.5rem;
    box-shadow: 0px 16px 44px -25px rgba(0, 0, 0, 0.25);

    z-index: 2;

  }

  .user-menu-drop-title{
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    border-bottom: 1px solid var(--gray-200);

    img{
      height: 67px;
      width: 67px;
    }

    h3{
      max-width: 205px;
      font-size: 1rem;
      font-weight: 700;
      margin-left: 1rem;

      &:first-child{
        margin-bottom: 0.5rem;

      }
    }
  }

  .seta-cima:before {
    content: "";
    position: absolute;
    display: inline-block;
    vertical-align: middle;
    top: -20px;
    left: 142px;
    width: 0px; 
    height: 0px; 

    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
    border-bottom: 20px solid var(--white);
  }
`

export const Item = styled.div`

  .user-menu-item-sections{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    border-bottom: 1px solid var(--gray-200);
    cursor: pointer;
    transition: background 0.2s;

    :hover{
      background: var(--gray-100);
    }

    > div {
      display: flex;
      justify-content: flex-start;
      gap: 10px;
      flex: 1;
      width: 100%;

      svg {
        color: rgb(140, 36, 88); 
        font-size: 26px;
      }

      span {      
        font-size: 16px;
        color: rgb(52, 58, 64);
        font-weight: 500;
      }
    }

    > img {
    
    }

    > h3{
      color: var(--gray-800);
      font-weight: 500;
    }

  }

  a{
    text-decoration: none;
  }

  .user-menu-dropdown-list{
    background: linear-gradient(231.01deg, var(--pink-200) 20.98%, var(--pink-400) 90.65%);

    .user-menu-item-sections{
      border-bottom: none;
      transition: filter 0.2s;

      :hover{
        background: linear-gradient(231.01deg, var(--pink-200) 20.98%, var(--pink-400) 90.65%);
        filter: brightness(0.9);
      }
    }


    h3{
      color: var(--white);
    }
  }
`
